import React from 'react'

import './styles.scss'

import windowsIcon from './windows.svg'
import { Layout, requirementsCopy } from '../Shared'

import ExperienceGuarantee from './guarantee'

import Emoji from '../Shared/Emoji'
import { IrisCTALinkButton, colors } from '../Shared/IrisCTALinkButton'

import queryString from 'query-string'
import { get } from '../../utils/request'

class Welcome extends React.Component {
  componentDidMount() {
    const { location } = this.props;
    const { search } = location;

    if (search) {
      // If there are URL query params, re-navigate to the page with state
      const queryParams = queryString.parse(search);
      if (queryParams.confirmation_token) {
        const token = queryParams.confirmation_token;

        get(`users/email-confirmation/${token}`)
          .then(() => {
            // Wait for window.analytics to be defined
            this.waitForAnalyticsAndTrack();
          })
          .catch(err => console.log(`Server error: ${err}`));
      }
    }
  }

  waitForAnalyticsAndTrack() {
    if (window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track('signup_email_verified');
    } else {
      setTimeout(() => this.waitForAnalyticsAndTrack(), 100);
    }
  }

  render() {
    return (
      <Layout>
        <div>
          <div className="main-content">
            <ChampionHeader />
          </div>
          <div className="main-content">
            <ExperienceGuarantee />
          </div>
        </div>
      </Layout>
    )
  }
}

export default Welcome

const ChampionHeader = ({ downloadProspectURL }) => (
  <div
    style={{ marginTop: '10em', paddingBottom: '4.0em', textAlign: 'center' }}
  >
    <div style={{ marginTop: '2.0em' }}>
      <span className="welcome-header">
        Welcome <Emoji label="celebrate" symbol={`\u{1F389}`}></Emoji>
      </span>
      <div>
        <div>
          <IrisCTALinkButton
            href={downloadProspectURL}
            cta={'Download Prospect'}
            customStyles={{
              maxWidth: 365,
              height: 52,
              borderRadius: 3,
            }}
          />
        </div>
        <div
          style={{ color: '#5C5C5C', marginTop: '2.0em', fontStyle: 'italic' }}
        >
          Runs on Windows PCs <WindowsLogo />
        </div>
      </div>
    </div>
  </div>
)
ChampionHeader.defaultProps = {
  downloadProspectURL: 'https://prospect-releases.irisvr.com/ProspectSetup.exe',
}
const WindowsLogo = () => (
  <img
    style={{ verticalAlign: 'middle', marginLeft: '0.5em' }}
    src={windowsIcon}
    alt="Windows Logo"
  />
)



const RequirementBullet = ({ category, copy }) => {
  const isHeadsetCategory = category === 'Headset'
  const displayCopy = isHeadsetCategory ? copy.welcome : copy
  return (
    <div>
      <span style={{ fontWeight: 'bold' }}>
        {category}: <span style={{ fontWeight: 'normal' }}>{displayCopy}</span>
      </span>
    </div>
  )
}

